/* eslint-disable */

var icon = require('vue-svgicon')
icon.register({
  'mail': {
    width: 14,
    height: 12,
    viewBox: '0 0 14 12',
    data: `<path pid="0" d="M1 0a1 1 0 0 0-1 1v.69l7 4.685 7-4.686V1a1 1 0 0 0-1-1H1zm13 2.94L7 7.624 0 2.939V11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2.94z"/>`
  }
})
